import React, {memo, useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton from '@s-ui/react-atom-button'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import IconBin from '@adv-mt/mt-svg-icons/lib/Bin'

const MEDIA_CARD_BUTTON_DESIGN = {
  design: 'flat',
  color: 'neutral'
}

const MediaCard = ({baseClass, isSmallSize, onRemoveVehicle = () => {}, vehicle: {make, model, version, imageSrc}}) => {
  const {i18n} = useContext(Context)

  const MEDIA_CARD_CLASS = `${baseClass}-mediaCard`
  const MEDIA_CARD_WRAPPER_CLASS = `${MEDIA_CARD_CLASS}Wrapper`
  const MEDIA_CARD_IMAGE_CLASS = `${MEDIA_CARD_CLASS}Image`
  const MEDIA_CARD_IMAGE_WRAPPER_CLASS = `${MEDIA_CARD_IMAGE_CLASS}Wrapper`
  const MEDIA_CARD_VEHICLE_CLASS = `${MEDIA_CARD_CLASS}Vehicle`
  const MEDIA_CARD_VEHICLE_WRAPPER_CLASS = `${MEDIA_CARD_VEHICLE_CLASS}Wrapper`
  const MEDIA_CARD_VEHICLE_MAKE_CLASS = `${MEDIA_CARD_VEHICLE_CLASS}Make`
  const MEDIA_CARD_VEHICLE_MODEL_CLASS = `${MEDIA_CARD_VEHICLE_CLASS}Model`
  const MEDIA_CARD_ACTION_WRAPPER_CLASS = `${MEDIA_CARD_CLASS}ActionWrapper`
  const MEDIA_CARD_ACTION_ICON_CLASS = `${MEDIA_CARD_CLASS}Icon`

  const BUTTON_TEXT = i18n.t('COMMON.REMOVE')

  const imageAlt = `${make} ${model} ${version}`

  const _handleRemoveVehicle = () => onRemoveVehicle()

  return (
    <div className={MEDIA_CARD_WRAPPER_CLASS}>
      <div className={MEDIA_CARD_IMAGE_WRAPPER_CLASS}>
        <div className={MEDIA_CARD_IMAGE_CLASS}>
          <AtomImage src={imageSrc} alt={imageAlt} />
        </div>
        {isSmallSize && (
          <div className={MEDIA_CARD_VEHICLE_WRAPPER_CLASS}>
            <h3 className={MEDIA_CARD_VEHICLE_MAKE_CLASS}>{make.toUpperCase()}</h3>
            <p className={MEDIA_CARD_VEHICLE_MODEL_CLASS}>{model}</p>
          </div>
        )}
      </div>
      {!isSmallSize && (
        <div className={MEDIA_CARD_ACTION_WRAPPER_CLASS}>
          <AtomButton
            {...MEDIA_CARD_BUTTON_DESIGN}
            isButton
            leftIcon={<IconBin className={MEDIA_CARD_ACTION_ICON_CLASS} />}
            fullWidth
            onClick={_handleRemoveVehicle}
          >
            {BUTTON_TEXT}
          </AtomButton>
        </div>
      )}
    </div>
  )
}

MediaCard.displayName = 'MediaCard'
MediaCard.propTypes = {
  baseClass: PropTypes.string.isRequired,
  isSmallSize: PropTypes.bool.isRequired,
  onRemoveVehicle: PropTypes.func,
  vehicle: PropTypes.shape({
    make: PropTypes.string.isRequired,
    model: PropTypes.string.isRequired,
    version: PropTypes.string.isRequired,
    imageSrc: PropTypes.string.isRequired
  }).isRequired
}

const MemoMediaCard = memo(MediaCard)
MemoMediaCard.displayName = 'MemoMediaCard'
export default MemoMediaCard
